interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  ogImageAlt?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage = '',
  ogImageAlt = '',
  articlePublishedTime = '',
  articleModifiedTime = '',
}: SEOMetaProps) {
  document.title = title;

  const setMeta = (name: string, content: string, property = false) => {
    if (!content) return;
    const attr = property ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('keywords', keywords);

  const canonicalEl = document.querySelector('link[rel="canonical"]');
  if (canonicalEl) canonicalEl.setAttribute('href', canonicalUrl);

  setMeta('og:title', title, true);
  setMeta('og:description', description, true);
  setMeta('og:type', ogType, true);
  setMeta('og:url', canonicalUrl, true);
  setMeta('og:site_name', '嫩草影院', true);
  setMeta('og:locale', 'zh_CN', true);
  if (ogImage) {
    setMeta('og:image', ogImage, true);
    if (ogImageAlt) setMeta('og:image:alt', ogImageAlt, true);
  }

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);

  if (articlePublishedTime) {
    setMeta('article:published_time', articlePublishedTime);
  }
  if (articleModifiedTime) {
    setMeta('article:modified_time', articleModifiedTime);
  }

  return null;
}